import { TaskRule } from 'src/app/interfaces/entities/task-rule';


export interface ConfigTask {
  id?: number;
  title?: string;
  nr?: string;
  departmentId?: number;
  note?: string;
  parentTaskId?: number;
  priority?: number;
  type: string;
  areaTypeIds: number[];
  /** Task tag catalog ids (#4864); project tasks inherit these. */
  tagIds?: number[];
  conditionDisplay?: string;
  /** Rules of the task template (#4962), loaded with the list. */
  rules?: TaskRule[];
  siteTask: boolean;
  milestoneRequirementId?: number;
  destinationPath?: string;
  templateFilename?: string;
  templateDocumentId?: number | null;
  templateFolderId?: number | null;
  helpLink?: string;
  userDefinedFields?: string;
  sortingIndex?: number;
  priorTaskId?: number;
  documentName?: string;
  validation?: boolean;
  estimatedHours?: number;
  taskPackageId?: number;
  isDeleted?: boolean;
  archived?: string | null;
}

export interface MappedConfigTask {
  id?: number;
  title?: string;
  departmentId?: number;
  nr?: string;
  note?: string;
  parentTaskId?: number;
  priority?: number;
  type: string;
  areaTypeIds: number[];
  /** Task tag catalog ids (#4864); project tasks inherit these. */
  tagIds?: number[];
  conditionDisplay?: string;
  /** Rules of the task template (#4962). */
  rules?: TaskRule[];
  /** True once "Apply" in the rules popup changed them: only then are they sent with the save. */
  rulesChanged?: boolean;
  siteTask: boolean;
  milestoneRequirementId?: number;
  destinationPath?: string;
  templateFilename?: string;
  templateDocumentId?: number | null;
  templateFolderId?: number | null;
  helpLink?: string;
  userDefinedFields?: string;
  sortingIndex?: number;
  priorTaskId?: number;
  documentName?: string;
  validation: boolean;
  estimatedHours?: number;
  isDeleted?: boolean;
  archived?: string | null;
  children?: MappedConfigTask[];
  expanded?: boolean;
  editing?: boolean;
  taskPackageId?: number;
  template?: File;
  SelectingProjects?: boolean;
  SelectedProjectIdsWhereTasksNotRequired?: number[];
  SelectedSiteIdsWhereTasksNotRequired?: number[];
}

export interface MappedConfigTreeNode{
    nodeId: string;
    parentNodeId: string | null;
    id ?: number;
    title: string;
    conditionDisplay: string;
    type?: string;
}



export enum TaskTypeEnum {
  Task = "task",
  Number = "number",
  Text = "text",
  Date = "date",
  Group = "group",
  Document = "document",
  YesNo = "yes/no",
  Contact = "contact",
  Note = "note",
  UserDefinedFields = "user defined selection",
  Contract = "contract",
}

export const TaskTypeText: Record<TaskTypeEnum, string> = {
  [TaskTypeEnum.Task]: $localize`:@@task:Task`,
  [TaskTypeEnum.Number]: $localize`:@@number:Number`,
  [TaskTypeEnum.Text]: $localize`:@@text:Text`,
  [TaskTypeEnum.Date]: $localize`:@@date:Date`,
  [TaskTypeEnum.Group]: $localize`:@@group:Group`,
  [TaskTypeEnum.Document]: $localize`:@@document:Document`,
  [TaskTypeEnum.YesNo]: $localize`:@@yesno:Yes/No`,
  [TaskTypeEnum.Contact]: $localize`:@@contact:Contact`,
  [TaskTypeEnum.Note]: $localize`:@@note:Note`,
  [TaskTypeEnum.UserDefinedFields]: $localize`:@@userDefinedFields:User Defined Fields`,
  [TaskTypeEnum.Contract]: $localize`:@@contract:Contract`,
};

export interface TaskType {
    value: TaskTypeEnum;
    text: string;
}

export const TaskTypes: TaskType[] = Object.entries(TaskTypeText).map(([value, text]) => ({
  value: value as TaskTypeEnum,
  text
}));

export interface TaskConfigTypeConfig{
    siteTask?: boolean;
    validation?: boolean;
    note?: boolean;
    areaTypeIds?: boolean;
    departmentId?: boolean;
    helpLink?: boolean;
    conditionDisplay?: boolean;
    priority?: boolean;
    milestoneRequirementId?: boolean;
    estimatedHours?: boolean;
    userDefinedFields?: boolean;
    documentName?: boolean;
    destinationPath?: boolean;  
    templateFilename?: boolean;
    tags?: boolean;
}

export const taskTypesConfig :  Record<TaskTypeEnum, TaskConfigTypeConfig> = {
    [TaskTypeEnum.Task]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Number]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Document]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        documentName: true,
        destinationPath: true,
        templateFilename: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Text]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Date]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.YesNo]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Contact]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Note]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.UserDefinedFields]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        userDefinedFields: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Contract]: {
        tags: true,
        siteTask:true,
        validation: true,
        note: true,
        areaTypeIds: true,
        departmentId: true,
        helpLink: true,
        conditionDisplay: true,
        priority: true,
        milestoneRequirementId: true,
        estimatedHours: false
    },
    [TaskTypeEnum.Group]: {
        conditionDisplay: true
    },
} 